<template>
  <div :style="this.height ? `height:${this.height}px;` : ''">
    <el-cascader
      ref="selector"
      v-model="datas"
      :placeholder="placeholder"
      :options="options"
      :props="props"
      :filterable="filterable"
      :clearable="clearable"
      :size="size"
      :show-all-levels="showAllLevels"
      :collapse-tags="collapseTags"
      class="dept-tree"
      :class="fullInput ? 'full-input' : ''"
      @change="changeValue"
      @visible-change="visibleChange"
      popper-class="dept-tree-popper"
      :disabled="disabled"
    ></el-cascader>
    <el-dialog
      append-to-body
      title="提示"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
      :show-close="false"
      :close-on-click-modal="closeOnClickModal"
    >
      <template #title>
        <!-- <div style="display:flex;">
          <el-input style="flex:1;margin-left:40px;"></el-input>
          <el-button size="small" style="width:60px;" type="text">查询</el-button>
        </div> -->
        <div style="padding: 0px 10px">
          <el-input
            placeholder="请输入部门名称"
            v-model="input3"
            class="input-with-select"
            @change="filterTree"
            @input="filterTree"
          >
            <template #prepend> 部门名称 </template>
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </template>
      <el-tree
        class="filter-tree"
        :data="options"
        :node-key="val"
        :props="props"
        default-expand-all
        show-checkbox
        ref="tree"
        :filter-node-method="filterNode"
        :check-strictly="checkStrictly"
        @check-change="checkChange"
        :default-checked-keys="defaultCheckedKeys"
        v-if="dialogVisible"
        check-on-click-node
      >
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import customerComponent from "@/assets/js/Mixins/CustomerComponent";
export default {
  mixins: [customerComponent],
  props: {
    value: {
      require: false,
      default() {
        return [];
      },
    },
    size: {
      type: String,
      default: "small",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    filterable: {
      type: Boolean,
      default() {
        return true;
      },
    },
    clearable: {
      type: Boolean,
      default() {
        return true;
      },
    },
    collapseTags: {
      type: Boolean,
      default() {
        return true;
      },
    },
    multiple: {
      type: Boolean,
      default() {
        return true;
      },
    },
    val: {
      type: String,
      default: "deptId",
    },
    label: {
      type: String,
      require: false,
      default: "deptName",
    },
    children: {
      type: String,
      default: "children",
    },
    showAllLevels: {
      type: Boolean,
      default() {
        return false;
      },
    },
    dataSource: {
      type: Array,
      default() {
        return null;
      },
    },
    checkStrictly: {
      type: Boolean,
      default: false,
    },
    isStorage: {
      type: Number,
      require: false,
      default: null,
    },
    checkKeys: [],
    closeOnClickModal: {
      type: Boolean,
      require: false,
      default() {
        return false;
      },
    },
    // 控制输入输入框大小
    fullInput: {
      type: Boolean,
      require: false,
      default() {
        return true;
      },
    },
    height: {
      type: Number,
      require: false,
      default() {
        return null;
      },
    },
    disabled: {
      type: Boolean,
      require: false,
      default() {
        return false;
      },
    },
    iNeedAll: {
      type: Boolean,
      require: false,
      default() {
        return false;
      },
    },
  },
  data() {
    return {
      options: this.dataSource || [],
      datas: [],
      rows: [],
      map: {},
      checkStrictly2: this.checkStrictly,
      dialogVisible: false,
      input3: "",
      select: "1",
      defaultCheckedKeys: [],
      map2: {},
    };
  },
  computed: {
    props() {
      return {
        multiple: this.multiple,
        value: this.val,
        label: this.label,
        checkStrictly: true, //this.checkStrictly2,
        children: "children",
        disabled: (data, node) => {
          // if(this.isStorage === undefined ||
          //    this.isStorage === null ||
          //    this.isStorage === '' ||
          //    this.isStorage === 'undefined' ||
          //    this.isStorage === 'null'){
          //   return false
          // }
          if (!data.disabled) {
            return false;
          }
          // 如果是叶子结点，则不能选择
          if (!data.hasChildren) {
            return true;
          }
          // 单选情况也不能选择
          if (this.checkStrictly) {
            return true;
          }
          // 多选情况，需要能选择上级
          return false;
        },
      };
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    const selector = this.selector();
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        return this.whileOpen();
      }
      this.handleClose();
    },
    value(val) {
      if (this.checkStrictly && !this.multiple) {
        let id = this.value;
        if (!id) {
        } else {
          id = parseInt(id);
          this.datas = this.map[id];
        }
      } else {
        this.datas = [];
        for (let i = 0; i < this.value.length; i++) {
          let id = this.value[i];
          id = parseInt(id);
          this.datas.push(this.map[id]);
        }
      }
      this.whileOpen();
    },
  },
  methods: {
    showPopup() {
      this.dialogVisible = true;
    },
    selector() {
      return this.$refs.selector;
    },
    handleClose(done) {
      this.$emit("close", this.rows);
      this.input3 = "";
      this.dialogVisible = false;
    },
    async getData() {
      let cacheKey = "dept-tree";
      if (
        this.isStorage !== null &&
        this.isStorage !== undefined &&
        this.isStorage !== "" &&
        this.isStorage !== "undefined" &&
        this.isStorage !== "0"
      ) {
        cacheKey += "-" + this.isStorage;
      }
      let tree = JSON.parse(window.sessionStorage.getItem(cacheKey));
      if (false && tree) {
        this.options = tree;
      } else {
        const params = {};
        if (this.isStorage != null) {
          params.isStorage = this.isStorage;
        }
        if (this.iNeedAll) {
          params.all = true;
        }
        const res = await this.$API.deptTree(params);
        this.options = res.data.result;
        window.sessionStorage.setItem(cacheKey, JSON.stringify(this.options));
      }
      this.$emit("ready", this.datas);
      this.toMap(null, this.options);
      if (this.value) {
        if (this.checkStrictly) {
          let id = this.value;
          id = parseInt(id);
          this.datas = this.map[id];
        } else {
          for (let i = 0; i < this.value.length; i++) {
            let id = this.value[i];
            id = parseInt(id);
            this.datas.push(this.map[id]);
          }
        }
        this.whileOpen();
      }
    },
    // 组装映射
    toMap(parent, items) {
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        const parentItems = parent ? this.map[parent.deptId] || [] : [];
        this.map[item.deptId] = [...parentItems, item.deptId];
        this.map2[item.deptId] = item;
        if (item.children) {
          this.toMap(item, item.children);
        }
      }
    },
    changeValue(rows) {
      this.rows = rows;
      if (!this.rows) {
        this.$emit("input", null);
        this.$emit("change", null);
        this.dispatch("ElFormItem", "el.form.change", [null]);
        return;
      }
      if (!this.checkStrictly || this.multiple) {
        if (this.checkStrictly) {
          const ids = rows.map((row) => row[row.length - 1]);
          this.$emit("input", ids);
          this.$emit("change", ids);
          this.dispatch("ElFormItem", "el.form.change", [ids]);
        } else {
          const ids = rows.map((row) => row[row.length - 1]);
          this.$emit("input", ids);
          this.$emit("change", ids);
          this.dispatch("ElFormItem", "el.form.change", [ids]);
        }
        return;
      }
      this.$emit("input", rows[rows.length - 1]);
      this.$emit(
        "change",
        rows[rows.length - 1],
        this.map2[rows[rows.length - 1]]
      );
      this.dispatch("ElFormItem", "el.form.change", rows[rows.length - 1]);
      this.$emit("change2", this.map2[rows[rows.length - 1]]);
      this.feedback(rows[rows.length - 1]);
    },
    visibleChange(visible) {
      if (visible) {
        this.dialogVisible = true;
        this.$emit("open", this.rows);
      } else {
        return;
      }
    },
    filterTree(val) {
      this.$refs.tree.filter(val);
    },
    filterNode(value, data) {
      if (!value) return true;
      return data[this.label].indexOf(value) !== -1;
    },
    sure() {
      this.datas = [];
      if (this.checkStrictly && !this.multiple) {
        const keys = this.$refs.tree.getCheckedKeys(!this.checkStrictly);
        let id = keys[0];
        id = parseInt(id);
        this.datas = this.map[id];
      } else {
        const keys = this.$refs.tree.getCheckedKeys();
        for (let i = 0; i < keys.length; i++) {
          let id = keys[i];
          id = parseInt(id);
          this.datas.push(this.map[id]);
        }
      }
      this.changeValue(this.datas);
      this.dialogVisible = false;
    },
    checkChange(node, checked) {
      if (!this.checkStrictly || this.multiple) {
        return;
      }
      if (!checked) {
        return;
      }
      this.$refs.tree.setCheckedNodes([node]);
    },
    whileOpen() {
      let keys = [];
      if (!this.datas || this.datas.length === 0) {
        this.defaultCheckedKeys = [];
        return;
      }
      if (this.checkStrictly && !this.multiple) {
        keys = [this.datas[this.datas.length - 1]];
      } else {
        for (let i = 0; i < this.datas.length; i++) {
          const item = this.datas[i];
          keys.push(item[item.length - 1]);
        }
      }
      this.defaultCheckedKeys = keys;
    },
  },
};
</script>

<style lang="less">
.dept-tree {
  width: 100%;
  height: 100%;
  .el-input {
    height: 100%;
  }
  &.full-input {
    .el-input__inner {
      height: 100% !important;
    }
  }
  .el-cascader__tags {
    height: 100%;
    align-items: center;
    flex-wrap: unset !important;
  }
  .el-cascader__search-input {
    display: none;
  }
  .el-icon-arrow-down {
    display: none;
  }
  .el-input__suffix {
    right: -2px !important;
  }
}
.dept-tree-popper {
  display: none;
}
.filter-tree {
  min-height: calc(50vh - 30px);
  max-height: 500px;
}
</style>